import { KeyPathOrGetter, Immutable, isImmutable } from 'nuclear-js'
import { Observable } from 'rxjs'
import { Subscriber } from 'rxjs'
import { reactor } from './reactor'

interface NuclearObservableConfig {
  toJS?: boolean;
}

const getVal = (v: Immutable.Iterable<any,any>|any, toJS: boolean): Immutable.Iterable<any,any>|any => {
  if (v) {
    return toJS && isImmutable(v) ? v.toJS() : v
  } else {
    return undefined
  }
}

export const NuclearObservable = {

  reactor: reactor,

  from: function<T>(getter: KeyPathOrGetter, config: NuclearObservableConfig = {}): Observable<T> {
    let val: Immutable.Iterable<any,any>

    return Observable.create((subscriber: Subscriber<T>) => {
      val = NuclearObservable.reactor.evaluate(getter)
      subscriber.next(getVal(val, config.toJS))

      const unobserveFn = NuclearObservable.reactor.observe(getter, (result => {
        val = result
        subscriber.next(getVal(val, config.toJS))
      }))

      return unobserveFn
    })
  },

  currentValue: function<T>(getter: KeyPathOrGetter, config: NuclearObservableConfig = {}): T {
    const val = NuclearObservable.reactor.evaluate(getter)
    return getVal(val, config.toJS)
  }
}
